import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import jwtDecode from 'jwt-decode';
import { MessageService } from 'primeng/api';
import { Subscription, first } from 'rxjs';
import { AppConfig } from 'src/app/models/appconfig';
import { ConfigService } from 'src/app/services/app.config.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styles: [`
    :host ::ng-deep .p-password input {
    width: 100%;
    padding:1rem;
    }

    :host ::ng-deep .pi-eye{
      transform:scale(1.6);
      margin-right: 1rem;
      color: var(--primary-color) !important;
    }

    :host ::ng-deep .pi-eye-slash{
      transform:scale(1.6);
      margin-right: 1rem;
      color: var(--primary-color) !important;
    }
  `]
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  public onAuthForm: FormGroup;
  valCheck: string[] = ['remember'];

  password: string;

  config: AppConfig;
  userData: any;
  subscription: Subscription;
  display: any;
  validationOTP: any;
  showPasswordsSections: boolean = false;
  disableUserName: boolean = false;
  submitted: boolean = false;

  constructor(private _formBuilder: FormBuilder, public configService: ConfigService, private authService: AuthenticationService, public router: Router, private service: MessageService, private cryptoJs: CryptoJsService) { }

  ngOnInit(): void {
    this.onAuthForm = this._formBuilder.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
      reEnteredPassword: ['', [Validators.required]],
      otp: ['', [Validators.required]],
    });

    this.config = this.configService.config;
    this.subscription = this.configService.configUpdate$.subscribe(config => {
      this.config = config;
    });
  }

  changePassword() {
    this.submitted = true;
    if (this.onAuthForm.status === "INVALID") {
      return;
    }
    if (this.f.password.value !== this.f.reEnteredPassword.value) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Password Doesnt Match with Re-Enter Password.' });
      return;
    }
    this.authService.changePasswordForUser(this.f.email.value, this.cryptoJs.Encrypt(this.f.password.value), this.cryptoJs.Encrypt(this.f.otp.value))
      .pipe(first())
      .subscribe({
        next: (data) => {
          console.log("data", data);
          if (data === 'Invalid OTP!..') {
            this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Invalid OTP' });
            return;
          }
          else if (data === 'Password Update Failed!.') {
            this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Password Update Failed' });
            return;
          }
          else if (data === 'Updated Successfully!.') {
            this.service.add({ severity: 'success', summary: 'Success Message', detail: 'Password Updated Successfully.' });
            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 2000);
          }
        },
        error: (res) => {
          console.log("res", res);
          this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! userid or password not correct.' });

        }
      });
  }

  get f() {
    return this.onAuthForm.controls;
  }

  onOTPClick() {
    if (!this.f.email.value) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'UserName/Email Cant be Empty.' });
      return;
    }
    this.f.otp.setValue('');
    this.authService.getOTPforUsers(this.f.email.value)
      .pipe(first())
      .subscribe({
        next: (data) => {
          console.log("Res Data", data)
          if (data === 'Invalid UserName!') {
            this.service.add({ severity: 'error', summary: 'Error Message', detail: data.toString() });
            return;
          }
          this.disableOTPButton(3);
          this.disableUserName = true;
          this.showPasswordsSections = true;
        },
        error: (err) => {
          console.log("Error", err);
          this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! OTP not generated.' });
        }
      });
  }

  disableOTPButton(minute) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        console.log("finished");
        clearInterval(timer);
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
